export default __webpack_public_path__ + "static/1005-24988bb2ab41a4fab73f37544b2851be.gif";